<template>
  <div>
    <div class="pay-header-container">
      <p class="title">充值成功后平台立即为你派单哦~</p>
      <p class="tip">钱包余额为 <span>{{priceYuan(over)}}元</span> 为避免影响平台派单，请尽快充值哦～</p>
      <div class="price">
        <div class="price-item" @click="activeIndex=index" v-for="(i,index) in priceList" :class="{active:activeIndex===index}" :key="i.id">
          <p>{{priceYuan(i.rechargeAmount)}}元</p>
          <span v-if="i.giftAmount">送{{priceYuan(i.giftAmount)}}元</span>
        </div>
      </div>
    </div>
    <div class="line-15"></div>
    <div class="payment-method-container">
      <p class="title">
        充值方式
      </p>
      <div class="pay-list">
        <div class="pay-item">
          <img src="@/assets/imgs/members/wx.png" alt="">
          <p>微信支付</p>
          <img class="checked" src="@/assets/imgs/members/buy-checked.png" alt="">
        </div>
      </div>
    </div>
    <div class="footer">
      <button @click="pay">立即充值</button>
      <div class="tip">
        <img class="checked" @click="protocolChecked = !protocolChecked" v-show="protocolChecked" src="@/assets/imgs/recharge/checked.png" alt="">
        <img class="checked" @click="protocolChecked = !protocolChecked" v-show="!protocolChecked" src="@/assets/imgs/recharge/no-checked.png" alt="">
        <p>我已阅读并同意</p>
        <a :href="protocols.lawyer_value_added_service_protocol">《增值服务购买协议》</a>
      </div>
    </div>
  </div>
</template>

<script>
import {lawyerRechargeServicerList, orderLawyerCreateOrder, orderLawyerPay, walletBalance} from "@a/recharge";
import {priceYuan} from "@/libs/tool";
import {protocols} from "@/libs/config";
import {callApp} from "@/libs/bridge";

export default {
  name: "index",
  data(){
    return{
      protocols,
      /*协议选择状态*/
      protocolChecked:false,
      /*金额列表选择的下标*/
      activeIndex:0,
      /*金额列表*/
      priceList:[],
      /*余额*/
      over:0
    }
  },
  mounted() {
    callApp('redirectUrl','empty')
    walletBalance().then(({data})=>{
      this.over = data&&data.totalBalance||0
    })
    lawyerRechargeServicerList().then(({data})=>{
      this.priceList = data||[]
    })
  },
  methods:{
    priceYuan,
    pay(){
      if(!this.protocolChecked){
        this.$toast('请同意增值服务购买协议')
        return false
      }
      const a = this.$toast.loading('加载中')
      /*创建订单*/
      orderLawyerCreateOrder({
        serviceId:this.priceList[this.activeIndex].id,
        type:1
      }).then(res=>{
        /*支付*/
       return  orderLawyerPay({
          orderId:res.data.orderId,
          payType:2
        }).then(({data})=>{
          const payResultMsg = JSON.parse(data.payResultMsg)
          window.location.href = payResultMsg.h5_url
         return data
        })
      }).then(()=>{
        a.clear()
      }).catch(()=>{
        a.clear()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 18px;
  font-weight: bold;
  color: #111111;
}

.pay-header-container {
  padding: 0 16px;

  .title {
    padding-top: 16px;
    padding-bottom: 13px;
  }

  .tip {
    font-size: 12px;
    font-weight: 400;
    color: #8A8D94;
    background: #F5F5F7;
    border-radius: 4px;
    padding-left: 16px;
    padding-top: 9px;
    padding-bottom: 9px;

    span {
      font-size: 12px;
      font-weight: 400;
      color: #262B2F;
    }
  }

  .price {
    display: flex;
    flex-wrap: wrap;
    padding-top: 5px;
    padding-bottom: 10px;

    .price-item {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 108px;
      height: 65px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #E0E0E3;
      box-sizing: border-box;
      font-weight: bold;
      margin-right: 8px;
      &:nth-child(3n){
        margin-right: 0;
      }
      p {
        font-size: 18px;
        font-weight: 500;
        color: #46474B;
      }

      span {
        font-size: 11px;
        padding-top: 5px;
        font-weight: 400;
        color: #46474B;
      }
    }

    .active {
      border-color: #4A549E;

      p, span {
        color: #4A549E;
      }
    }
  }
}

.payment-method-container {
  padding-bottom: 100px;
  .title {
    padding-top: 12px;
    padding-left: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ECECEC;
  }
  .pay-list{
    .pay-item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 56px;
      padding-left: 20px;
      img{
        width: 18px;
        height: 18px;
      }
      p{
        padding-left: 8px;
        flex: 1;
        font-size: 14px;
        font-weight: 400;
        color: #46474B;
      }
      .checked{
        padding-right: 28px;
      }
    }
  }
}
.footer{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  button{
    width: 342px;
    height: 44px;
    background: #4A549E;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    border: none;
  }
  .tip{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    .checked{
      width: 16px;
      height: 16px;
      padding-right: 8px;
    }
    a,p{
      font-size: 14px;
      font-weight: 400;
      color: #323233;
    }

    a{
      color: #D4B37D;
    }
  }
}

</style>
